import { LOCKED_LABELS, SALES_LABELS } from './consts'
import { cn } from 'src/shared/components/ui/utils'
import { SubItem } from './types'

export const getSidebarNavItemClassName = ({
  isActive,
  isCollapsed,
  isSub = false,
  isLast = false,
  isLocked = false,
}: {
  isActive: boolean
  isCollapsed: boolean
  isSub?: boolean
  isLast?: boolean
  isLocked?: boolean
}) =>
  cn(
    'sidebar-nav-item w-full cursor-pointer items-center',
    isSub && 'sidebar-nav-item--sub',
    isActive && 'sidebar-nav-item--active',
    isCollapsed ? 'justify-center px-1 py-2' : isSub ? 'gap-3 px-3 py-2' : 'gap-3 px-3 py-2.5',
    isLast && 'mt-auto',
    isLocked && 'opacity-60'
  )

export const isSubItemActive = (subItems: SubItem[], pathname: string) => {
  return subItems?.some(
    (subItem) =>
      pathname === subItem.href || pathname.startsWith(`${subItem.href}/`)
  )
}

export const isItemLocked = (label: string, isLocked: boolean) => {
  if (!isLocked) return false
  return LOCKED_LABELS.includes(label as (typeof LOCKED_LABELS)[number])
}

export const isSalesItem = (label: string) => {
  return SALES_LABELS.includes(label as (typeof SALES_LABELS)[number])
}

export const isNavItemActive = (href: string, pathname: string) => {
  // Exact match for section roots so `/admin` does not stay active on `/admin/orders`
  if (href === '/admin' || href === '/app') {
    return pathname === href
  }
  return pathname === href || pathname.startsWith(`${href}/`)
}
